import { HttpContextToken } from '@angular/common/http';

// Create a context token for passing AbortSignal to HTTP interceptors
export const ABORT_SIGNAL = new HttpContextToken<AbortSignal | undefined>(
    () => undefined
);

/**
 * When set, `ApiInterceptor` answers a 403 "terms of service have not been
 * accepted" with a `TermsOfServiceNotAcceptedError` instead of completing
 * silently (`EMPTY`). The redirect to `/settings/tos` happens either way.
 */
export const THROW_ON_TERMS_NOT_ACCEPTED = new HttpContextToken<boolean>(
    () => false
);

/**
 * Thrown by `ApiInterceptor` for requests carrying
 * `THROW_ON_TERMS_NOT_ACCEPTED`. It has already navigated to `/settings/tos`,
 * so callers must not redirect anywhere else.
 */
export class TermsOfServiceNotAcceptedError extends Error {
    constructor() {
        super('The terms of service have not been accepted.');
        this.name = 'TermsOfServiceNotAcceptedError';
        Object.setPrototypeOf(this, TermsOfServiceNotAcceptedError.prototype);
    }
}
